export enum HOTEL_TYPE {
  OTHER = 'other',
}
